// Ad platforms (Meta, TikTok, Google Ads, LinkedIn, OpenAI) only get data from
// the production deployment. Local dev servers and preview deployments use the
// production pixel ids and API credentials, so without these checks every test
// visit or test purchase reaches them as a real page view or conversion (and
// Meta asks to allowlist localhost and the vercel.app preview domains).

/** Server code: VERCEL_ENV is read at runtime and is unset in `next dev`. */
export function canSendServerAdEvents(): boolean {
  return process.env.VERCEL_ENV === "production";
}

/**
 * Browser code: Vercel exposes NEXT_PUBLIC_VERCEL_ENV and Next.js inlines it
 * at build time. Unset in `next dev`.
 */
export function canLoadBrowserAdTags(): boolean {
  return process.env.NEXT_PUBLIC_VERCEL_ENV === "production";
}
